import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const AZUL = '#1F8FE0';
const NAVY = '#0E2A47';

const LINEAS = {
  pasamanos_acero_inox: 'Pasamanos',
  ventanas_puertas_euro: 'Ventanas Euro',
  fachadas_vidrio_templado: 'Fachadas',
  duchas_mamparas: 'Duchas',
  techo_curvo: 'Techo Curvo',
};

const Comparador = ({ item }) => {
  const [pos, setPos] = useState(50);
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-testid={`antes-despues-${item.id}`}>
      <div className="relative select-none h-64 sm:h-72">
        <img src={item.despues_url} alt="Después" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
          <img src={item.antes_url} alt="Antes" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
        </div>
        <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.5)]" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-white shadow-lg flex items-center justify-center text-slate-700 font-black text-sm">⟷</span>
        </div>
        <span className="absolute top-2 left-2 bg-black/60 text-white text-[10px] font-black px-2 py-0.5 rounded uppercase tracking-wide">Antes</span>
        <span style={{ background: AZUL }} className="absolute top-2 right-2 text-white text-[10px] font-black px-2 py-0.5 rounded uppercase tracking-wide">Después</span>
        <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
          aria-label="Comparar antes y después" data-testid={`antes-despues-slider-${item.id}`}
          className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" />
      </div>
      <div className="px-4 py-3 flex items-center justify-between gap-3">
        <p className="text-sm font-black" style={{ color: NAVY }}>{item.caption || 'Transformación real'}</p>
        <span className="text-[10px] font-black uppercase tracking-wide shrink-0" style={{ color: AZUL }}>{LINEAS[item.producto] || ''}</span>
      </div>
    </div>
  );
};

export const AntesDespues = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/api/landing/antes-despues`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <div className="mt-14" data-testid="seccion-antes-despues">
      <p style={{ color: AZUL }} className="font-black text-xs tracking-[0.25em] uppercase mb-2 text-center">La prueba del cambio</p>
      <h3 className="text-xl sm:text-2xl font-black text-center mb-2" style={{ color: NAVY }}>
        Antes y <span style={{ color: AZUL }}>después</span>
      </h3>
      <p className="text-slate-500 text-sm text-center mb-6">Desliza la barra para ver la transformación.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {items.map((it) => <Comparador key={it.id} item={it} />)}
      </div>
    </div>
  );
};
